/**
 * Shared main-pane container geometry for the Executive View.
 *
 * Every screen in the right-hand pane (brand picker, question library,
 * answer view) uses the same max width, centering, and horizontal
 * padding so their body left edges align exactly as the user navigates
 * between them (2026-08-16 UI review). Vertical padding stays
 * per-screen. Spread this first, then add screen-specific keys.
 */
export const EXEC_CONTENT_CONTAINER_SX = {
  maxWidth: 1100,
  mx: 'auto',
  px: 4,
} as const;
